import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Header from './Header';

const ModalMakePaymentForClientRentalsForm = () => {
  const server_app_api_php = window.SERVER_APP_API_PHP;

  const [houseNumberPOP, setHouseNumberPOP] = useState("");
  const [datePOPHouses, setDatePOPHouses] = useState("");
  const [amountPOPHouses, setAmountPOPHouses] = useState("");
  const [POPHouses, setPOPHouses] = useState(null);
  const [companyID, setCompanyID] = useState("");
  const [businessLocationID, setBusinessLocationID] = useState("");
  const [isFormValid, setIsFormValid] = useState(false);
  const [houseOptions, setHouseOptions] = useState([]);

  useEffect(() => {
    const formData = new FormData();
    formData.append("apiType", 'getPOPHousesOnUploadForm');
    formData.append("businessLocationID", businessLocationID);

    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        setHouseOptions(response.data);
      })
      .catch(error => {
       // alert('There was an error fetching the houses!', error);
      });
  }, [companyID, businessLocationID]);

  useEffect(() => {
    setIsFormValid(houseNumberPOP && datePOPHouses && amountPOPHouses && POPHouses);
  }, [houseNumberPOP, datePOPHouses, amountPOPHouses, POPHouses]);

  const handleInputChange = (e) => {
    const { id, value, files } = e.target;
    if (id === "POPHouses") {
      setPOPHouses(files[0]);
    } else {
      switch (id) {
        case "houseNumberPOP":
          setHouseNumberPOP(value);
          break;
        case "datePOPHouses":
          setDatePOPHouses(value);
          break;
        case "amountPOPHouses":
          setAmountPOPHouses(value);
          break;
        case "companyID":
          setCompanyID(value);
          break;
        case "businessLocationID":
          setBusinessLocationID(value);
          break;
        default:
          break;
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("houseNumberPOP", houseNumberPOP);
    formData.append("datePOPHouses", datePOPHouses);
    formData.append("amountPOPHouses", amountPOPHouses);
    formData.append("POPHouses", POPHouses);
    formData.append("companyID", companyID);
    formData.append("businessLocationID", businessLocationID);
    formData.append("apiType", 'uploadPOPHouses');

    axios.post(`${server_app_api_php}/server/index.php`, formData)
      .then(response => {
        alert(response.data);
        setHouseNumberPOP("");
        setDatePOPHouses("");
        setAmountPOPHouses("");
        setPOPHouses(null);
        setCompanyID("");
        setBusinessLocationID("");
      })
      .catch(error => {
        alert('Error: Please Check Your Internet Connection. If This Persists, Kindly Contact Support Team');
      });
  };
  return (
    <>
      <main className='bg-white'>
        <Header />
        <hr />
        <div className="mt-5" id="modalMakePaymentForClientRentalsForm">
          <div className="modal-dialog modal-lg modal-notify modal-info" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <p className="heading lead">Upload Proof Of Payment For Houses</p>
              </div>
              <div className="modal-body">
                <form id="fileUploadFormPOPHouses" onSubmit={handleSubmit} encType="multipart/form-data">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 mb-4 text-left">
                      <label htmlFor="houseNumberPOP">House Number</label>
                      <select className="custom-select d-block w-100" id="houseNumberPOP" name="houseNumberPOP" value={houseNumberPOP} onChange={handleInputChange}>
                        <option value="">Choose...</option>
                        {houseOptions.map(option => (
                          <option key={option.rentalsID} value={option.rentalsID}>
                            Block = {option.block}, House Number = {option.houseNumber}, Tenant = {option.tenantNameDB}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-lg-3 col-md-12 mb-2 text-left">
                      <div className="md-outline">
                        <label htmlFor="datePOPHouses">Date</label>
                        <input type="date" className="form-control" id="datePOPHouses" name="datePOPHouses" value={datePOPHouses} onChange={(e) => setDatePOPHouses(e.target.value)} />
                      </div>
                    </div>
                    <div className="col-lg-3 col-md-12 mb-2 text-left">
                      <div className="md-outline">
                        <label htmlFor="amountPOPHouses">Amount</label>
                        <input type="text" className="form-control" id="amountPOPHouses" name="amountPOPHouses" value={amountPOPHouses} onChange={(e) => setAmountPOPHouses(e.target.value)} />
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12 mb-2 text-left">
                      <div className="md-outline">
                        <label htmlFor="POPHouses">Proof Of Payment</label>
                        <input type="file" className="form-control" id="POPHouses" name="POPHouses" onChange={handleInputChange} />
                      </div>
                      <input type="hidden" id="companyID" name="companyID" value={companyID} onChange={(e) => setCompanyID(e.target.value)} />
                      <input type="hidden" id="businessLocationID" name="businessLocationID" value={businessLocationID} onChange={(e) => setBusinessLocationID(e.target.value)} />
                      <input type="hidden" id="apiType" name="apiType" value="uploadPOPHouses" />
                    </div>
                  </div>
                  <div className="text-center mt-0">
                    <button type="submit" className="btn btn-success" id="uploadPOPHouses" disabled={!isFormValid}>
                      Upload POP <i className="fas fa-coins ml-1"></i>
                    </button>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ModalMakePaymentForClientRentalsForm;
